import React from "react";
import profile from "../../../../assets/img/Home/profile.png";
import eye from "../../../../assets/img/admin/eye-outline.svg";
const AdminUserCommentsrow = ({info}) => {
  return (
    <div className="AdminUserCommentsrow flex justify-between  items-center mb-[16px]">
      <div className="flex gap-[12px] items-center AdminUserCommentsrow--profile" >
           <img src={info.author.avatar} />
           <div>
               <div className="flex items-center">
                   <h6  className="text-[20px] font-[700] text-[#12171C]">{info.author.full_name}</h6>
                   <p className="text-[14px] font-[400] text-[#797D82]">{info.created_at}</p>
               </div>
               <p className="text-[16px] font-[500] text-[#292D32] mt-[8px]">برای {info.residence_title}دیدگاه جدیدی ثبت کرد</p>
           </div>
      </div>
    <div className="flex items-center gap-[8px]">
    <button className="w-[56px] h-[56px] rounded-[14px] bg-[#F0F5F7] center">
     <img src={eye}/>
      </button>
      <button className={`text-[16px] px-[32px] py-[15px] font-[500] rounded-[14px] bg-[#D6EDD7] text-[#189A35] center`}>
   <p>در انتظار تایید</p>
      </button>
    </div>
    </div>
  );
};

export default AdminUserCommentsrow;
